import {
  mergeSx,
  RatioProgressBar,
  RatioProgressBarProps,
  SxProps,
} from '@cast/design-system';

import { computeSpendColorsMap, ComputeSpendType } from 'types/cost-report';

type StackedProgressBarProps = {
  fallback: number;
  spot: number;
  storage?: number;
  sx?: SxProps;
};

export const NodeTypesProgressBar = ({
  fallback,
  spot,
  storage,
  sx,
}: StackedProgressBarProps) => {
  const bars: RatioProgressBarProps['bars'] = [];

  if (spot) {
    bars.push({
      value: spot,
      color: computeSpendColorsMap[ComputeSpendType.SPOT],
    });
  }

  if (fallback) {
    bars.push({
      value: fallback,
      color: computeSpendColorsMap[ComputeSpendType.FALLBACK],
    });
  }

  if (storage) {
    bars.push({
      value: storage,
      color: computeSpendColorsMap[ComputeSpendType.STORAGE],
    });
  }

  return (
    <RatioProgressBar
      testId="nodes-count-progress-bar"
      hideBorders
      size="md"
      total={100}
      bars={bars}
      sx={mergeSx(
        { backgroundColor: computeSpendColorsMap[ComputeSpendType.ON_DEMAND] },
        sx
      )}
    />
  );
};
